import api from "../config/api";


export const createLogin = async (data)=>{
    const res = await api.post(`/admin/login/`,data)
    console.log(res.data);
    
    return res.data;
}
